import { Strings } from "src/app/common/utility/string/string";

export class LoginResult {
    constructor(
        public loggedIn: boolean = false,
        public username: string = Strings.Empty,
        public emailAddress: string = Strings.Empty,
        public errorMessage: string = Strings.Empty,
        public accessToken: string = Strings.Empty,
        public idToken: string = Strings.Empty,
        public refreshToken: string = Strings.Empty,
        public CognitoUser: any | undefined = undefined
    ) { }

    public static empty(): LoginResult {
        return new LoginResult(false, Strings.Empty, Strings.Empty, Strings.Empty, Strings.Empty, Strings.Empty)
    }
}
